import script from "./SuccessActivationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessActivationPage.vue?vue&type=script&setup=true&lang=js"

import "./SuccessActivationPage.vue?vue&type=style&index=0&id=7cf98858&lang=scss"

const __exports__ = script;

export default __exports__